<template>
  <div>
    <h1>系统开发中，带来不便，请谅解。。。。。。。。</h1>
    <img src="../assets/lost.jpg" alt="">
  </div>
</template>

<script>
    export default {
        name: "developing"
    }
</script>

<style lang="less" scoped>
  div{
    position: relative;
    img{
      width: 100%;
    }
    text-align: center;
    h1{
      position: absolute;
      top:50px;
      left: 35%;
      text-align: center;
      color: red;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/developing.vue